import TemplateView from '../TemplateView'
import messageResource from '../messageResource'
import Button from '../components/Button'

export class CreateTasksLightboxFooter extends TemplateView {
    constructor() {
        super()
    }

    templateHtml() {
        return '<div class="createLightBoxFooter">' +
               '    <div class="errorMessageBox">' +
               '        <div class="errorIcon"/>' +
               '        <span class="errormsg"></span>' +
               '    </div>' +
               '    <div class="buttonsBox">' +
               '        <span class="changesMsg"><%-changeMsg%></span>' +
               '        <span class="savingMsg"><%-savingMsg%></span>' +
               '        <div class="commitButtonPlaceHolder"/> ' +
               '        <div class="greyButton cancelBtn"><%-cancelMsg%></div>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            changeMsg: 'add_new_tasks.not_saved',
            savingMsg: 'add_new_tasks.saving',
            cancelMsg: 'common.cancel'
        }
    }

    afterRender() {
        let title = messageResource.getMessage("add_new_tasks.create_tasks_btn_title")
        if(title.length > 17) {
            title = messageResource.getMessage("add_new_tasks.default_create_tasks_btn_title")
        }
        this.commitButton = new Button({
            label: title,
            withPlusIcon: true,
        }).init(this.find('.commitButtonPlaceHolder'))
    }

    getCommitBtnEl() {
        return this.commitButton.getEl()
    }

    getCancelBtnEl() {
        return this.find('.cancelBtn')
    }
}

export default CreateTasksLightboxFooter



// WEBPACK FOOTER //
// ./web/js/addNewTasks/CreateTasksLightboxFooter.js